<template>
  <v-dialog
    max-width="1000px"
    :model-value="show"
    @update:model-value="$emit('update:show', $event)"
  >
    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between">
          <typography size="1.25rem">Directory</typography>
          <v-btn icon color="normal" variant="text">
            <v-icon @click="$emit('update:show', false)">mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-divider
        class="m-0"
        color="primary500"
        style="border-top-width: 2px !important"
      ></v-divider>
      <v-card-item>
        <div class="d-flex gap-3 mt-2 align-center">
          <v-text-field
            color="gray200"
            label="Search"
            placeholder="Search"
            prepend-inner-icon="mdi-magnify"
            class="custom-input"
            density="comfortable"
            v-model="state.search"
            v-if="!showAddStudent"
          ></v-text-field>

          <div class="d-flex flex-grow-1 gap-3" v-if="showAddStudent">
          <v-text-field  class="custom-input" placeholder="Student ID" v-model="newStudent.id" :loading="newStudent.loading"></v-text-field>
          <v-btn class="p2" @click="addStudent(newStudent)" :loading="newStudent.loading" :disabled="newStudent.loading">Add Student ID</v-btn>
          <v-btn class="p2" @click="showAddStudent=false">Cancel</v-btn></div>
          <ToggleBtn v-model="state.column" color="gray200" v-if="!showAddStudent">
            <button
              value="students"
              :class="[{ current: state.column === 'students' }]"
              @click="state.column = 'students'"
            >
              <Typography color="gray800" weight="600">Students</Typography>
              
            </button>
            <button
              value="parents"
              :class="[{ current: state.column === 'parents' }]"
              @click="state.column = 'parents'"
            >
              <Typography color="gray800" weight="600">Parents</Typography>
            </button>
          </ToggleBtn>
          <v-btn v-if="!showAddStudent" icon="mdi-plus" @click="showAddStudent=!showAddStudent"></v-btn>
        </div>

        <div class="data-con">
          <table>
            <thead>
              <tr>
                <th v-for="column in columns" :key="column">
                  <typography color="gray600" weight="500" size="0.875rem">{{ column }}</typography>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in columnData" :key="item.name + item.sub.join(',')">
                <td>{{ item.name }}</td>
                <td>{{ item.sub.join(", ") }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card-item>
      <v-card-actions v-if="false">
        <v-spacer></v-spacer>
        <v-btn variant="flat" style="text-transform: capitalize">Save Changes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import Typography from "@/components/typography.vue";
import { computed, reactive, ref } from "vue";
import { FetchService } from "@/services/fetch.service";

import ToggleBtn from "../toggleBtn.vue";
import { useAuthenticationStore } from "@/stores/authentication";
import { useConferenceStore } from "@/stores/teacher/conference";
import { complexSearch } from "@/utils";

defineProps<{
  show: boolean;
}>();
defineEmits<{
  (event: "update:show", val: boolean): void;
}>();
type Student = {
  id: string | null;
  loading: boolean;
  firstname: string | null;
  lastname: string | null;
  description: string | null;
  school_id: number | null;
};
const showAddStudent = ref(false);
const conferenceStore = useConferenceStore();
const newStudent = reactive<Student>({
  id: null,
  loading: false,
  firstname: null,
  lastname: null,
  description: null,
  school_id: conferenceStore.current_conferences[0]?.school_id
});
const authStore = useAuthenticationStore();

const state = reactive({
  column: "students" as "students" | "parents",
  search: ""
});
const columns = computed(() => {
  if (state.column == "students") return ["STUDENTS", "PARENTS"];
  return ["PARENTS", "STUDENTS"];
});

const columnData = computed(() => {
  let data: { name: string; sub: string[] }[] = [];
  if (state.column == "students") {
    data = authStore.me.students.map((s) => ({
      name: `${s.child_fname} ${s.child_lname}`,
      sub: s.guardians.map((g) => `${g.firstname} ${g.lastname}`)
    }));
  } else
    data = authStore.me.guardians.map((g) => ({
      name: `${g.firstname} ${g.lastname}`,
      sub: g.students.map((s) => `${s.child_fname} ${s.child_lname}`)
    }));
  if (state.search) {
    data = data.filter((i) => complexSearch(state.search, i.name + i.sub.join(", ")));
  }
  return data;
});
async function addStudent(student: Student) {
  if (student.id == ' '){
    console.log("Space is not valid for student name");
    return false;
  }
  student.loading = true;

  if (student.id != undefined) {
    await FetchService.fetchData("/teachers/" + authStore.me.uid + "/attachstudent", "put", student);
    await authStore.fetchProfile();
  }
  student.loading = false;
  showAddStudent.value=false
  
}

</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.card-bg-color {
  background-color: $primary-25;
}

.data-con {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 30px;
  table {
    width: 100%;
    thead {
      th {
        padding-bottom: 5px;
        padding-left: 5px;
      }
    }
    tbody {
      background-color: white;
      tr {
        &:first-child td {
          border-top: 1px solid $primary-75;
        }
        td {
          padding: 8px;
          border-bottom: 1px solid $primary-75;
          &:last-child {
            border-right: 1px solid $primary-75;
          }
          &:first-child {
            border-left: 1px solid $primary-75;
          }
        }
      }
    }
  }
}
</style>
